import { Person } from "./person";

export class Parent extends Person {
    parent_id: number;
    public occupation: string;
    public qualification: string;
    public company_name: string;
    public relationship: string;
    public is_local_guardian: boolean;
    public designation: string;
    public mother_toungue: string;
}